<!-- 
    가장 최근의 SnapshotData를 기준으로 Type별 Status의 현황을 보여주는 그래프

 -->

 <template>
    <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap h-80" style="margin: 0;">
        <loading :active="loading"/>

        
        <div class="change-today-graph h-100" style="flex:3; position: relative; padding:0;">
            <apexchart v-if="showGraph" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions"
                :series="graphSeries" />
        </div>
    </b-row>
    <!-- <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap" :class="isFlexible ? 'h-100' : 'h-80'" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="series" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        
        <div class="change-today-graph h-100" style="flex:3; position: relative;" :style="isFlexible ? 'padding: 20px 0;' : 'padding: 0;'">
            <apexchart v-if="series" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions"
                :series="series" />
        </div>
        <div v-if="isFlexible && tableData" class="d-flex align-items-center justify-content-center flex-column h-100" style="flex:1">
            <ChartTable :tableData="tableData"/>
        </div>
    </b-row> -->
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
    name: 'WeekendAndHolidayDocument',
    components: {
        apexchart: VueApexCharts,
    },
    created() {

        this.chartOptions.labels = ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
        this.graphSeries = [
            {
                name: '전환 회원',
                data: [15213, 14213, 12551, 22123, 14512, 31213, 15122, 15235, 31211, 15212, 15213]
            }
        ]
        this.showGraph = true;
    },
    data() {
        return {
            loading : false,
            showGraph: false,
            graphSeries: [],
            graphLabels: [],
            chartOptions: {
                chart: {
                    height:'80%',
                    type: "donut",
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                        csv: {
                            filename: undefined,
                            columnDelimiter: ',',
                            headerCategory: 'category',
                            headerValue: 'value',
                            dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                            }
                        },
                        svg: {
                            filename: undefined,
                        },
                        png: {
                            filename: undefined,
                        }
                        },
                        autoSelected: 'zoom' ,
                    },
                },
                colors: ['#142459', '#176BA0', '#19AADE', '#1AC9E6', 'red'],
                // plotOptions: {
                //     bar: { 
                //         columnWidth : '100%',
                //         distributed: true,
                //     }
                // },
                labels : [],
                dataLabels:{
                    enabled:true,
                    formatter: function(value, { seriesIndex, dataPointIndex, w }) {
                        return w.config.series[seriesIndex];
                    }
                },
                plotOptions: {
                    pie: {
                        expandOnClick: false,
                        donut: {
                            size: '60%',
                            labels: {
                                show: this,
                                value: {
                                    show: true,
                                    color: '#2E2E38',
                                    fontSize: '20px',
                                    fontWeight: '700',
                                    offsetY: 0,
                                    formatter: val => this.formatNumber(val, 0)
                                },
                                total: {
                                    show: true,
                                    label: 'Total',
                                    color: '#747480',
                                    fontSize: '14px',
                                    formatter: chart => {
                                        const total = chart.config.series.reduce((a, b) => a + b, 0)
                                        return this.formatNumber(total, 0)
                                    }
                                },
                            },
                        },
                        margin: 0,
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val;
                        }
                    },
                },

                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: 0,
                    fontSize: '12px'
                },
                grid :{
                    show:false
                }
            },
        }
    },
    methods: {

    },
}
</script>
<style scoped>
.count-label {
    font-size: 2.25rem !important;
    font-weight: 500;
}
.count-data {
    margin-top: 20px;
    font-size: 2.5rem;
    font-weight: 600;
}

.h-80 {
    padding-top: 10px;
    height: 80%;
}
.h-90 {
    height: 90%;
}
</style>
<style>
/* 커스텀 툴팁 스타일 */
.change-today-graph .apexcharts-tooltip {
    border-radius: 100px;
    border: 1px solid #FFF;
    background: transparent;
    color: #FFF;
    font-family: 'NanumGothic';
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.20);
}
.change-today-graph .apexcharts-tooltip-series-group.apexcharts-active {
    padding: 0 12px;
}
</style>